var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"rounded":"","color":"primary"},on:{"click":function($event){return _vm.click($event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fa-save")]),_vm._v("\n\t"+_vm._s(_vm.$t('common.save'))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }